<app-dialog-container>
    <table-responsive
    table
    [length]="length"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    (openDelete)="openDelete($event)"
    (openShow)="_openShow($event)"
    [showLock]="false"
    [showPlayButton]="false"
    [length]="length"
    [configColumns]="configColumns"
    [currentTab]="currentTab" 
    [userType]="userType" 
    [hasAdd] = 'false'
    (filter)="filter($event)"
    [showCalendar]="true"
  ></table-responsive>
</app-dialog-container>